import { Text } from "@src/lib/ui-react";
import { useIsRebrand } from "@src/appV2/redesign/theme/RebrandProvider";
import { useTheme } from "@mui/material/styles";
import { useDisplayTime } from "./useDisplayTime";

export interface LocalTimeProps {
  timeZone?: string;
}

export function LocalTime(props: LocalTimeProps) {
  const { timeZone } = props;
  const localTime = useDisplayTime({ timeZone });
  const isRebrand = useIsRebrand();
  const theme = useTheme();

  return (
    <Text color={isRebrand ? theme.palette.navbar?.itemContent : "white"} variant="body2">
      Local time: {localTime}
      {timeZone ? ` (${timeZone}) ` : null}
    </Text>
  );
}
